import { useHistory } from 'react-router-dom';

export const NotFoundPage = () => {
    const history = useHistory();
    const hasAccessToken = !!sessionStorage.getItem('access_token');

    const redirectToHome = () => {
        history.push('/dashboard');
    };

    return (
        <div className="main-container">
            <div className="error-container" style={{ textAlign: 'center', padding: '0 16px' }}>
                <img src="https://cdn-icons-png.flaticon.com/512/564/564619.png" style={{ width: 200, marginBottom: 32 }} alt="404" />
                <h1 style={{ textAlign: 'center', color: 'white', marginTop: 32, marginBottom: 16, fontSize: 48 }}>404</h1>
                <h3 style={{ color: 'white', marginBottom: 12 }}>Page not found</h3>
                <p>The URL you entered does not exist.</p>
                {
                    hasAccessToken &&
                    <button
                        type="button"
                        onClick={redirectToHome}
                        style={{
                            marginTop: 24,
                            border: 'none',
                            borderRadius: 6,
                            padding: '10px 20px',
                            cursor: 'pointer',
                            color: '#2D72D9',
                            fontWeight: 700
                        }}
                    >
                        Go to Dashboard
                    </button>
                }


            </div>
        </div>
    );
};
